import { Pipe, PipeTransform } from '@angular/core';
import { ScheduleService } from './schedule/schedule.service';
import { DatePipe } from '@angular/common';


@Pipe({ name: 'range' })
export class RangePipe implements PipeTransform {
	transform(length: number, offset: number = 0, step: number = 1): number[] {
		return new Array(length || 0).fill(0).map((n, index) => offset + index);
	}
}


@Pipe({ name: 'moneyPipe' })
export class MoneyPipe implements PipeTransform {
	transform(x: number, fixed: number = 2): string {
		var parts = (+x).toFixed(fixed).toString().split(".");
		parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
		return parts.join(".");
	}
}

@Pipe({ name: 'tzdate', pure: false })
export class tzDatePipe implements PipeTransform {
	constructor( private schedule: ScheduleService, private date: DatePipe ){}
	transform(value: string | Date, format: string): string {
		return this.date.transform(value, format, this.schedule.tz).replace( /TT/g, this.schedule.tz_label );
	}
}


@Pipe({ name: 'fileSize' })
export class FileSizePipe implements PipeTransform {

	private units = [
		'bytes',
		'KB',
		'MB',
		'GB',
		'TB',
		'PB'
	];

	transform(bytes: number = 0, precision: number = 2 ) : string {
		if ( isNaN( parseFloat( String(bytes) )) || ! isFinite( bytes ) ) return '?';

		let unit = 0;

		while ( bytes >= 1024 ) {
			bytes /= 1024; unit ++;
		}

		return bytes.toFixed( + precision ) + '' + this.units[ unit ];
	}
}


@Pipe({ name: 'secondsFromNow' })
export class RelativeSecondsPipe implements PipeTransform {

	transform(secondsLeft: number): string {
		const now = new Date();
		const targetDate = new Date(now.getTime() + secondsLeft * 1000);

		const diff = targetDate.getTime() - now.getTime();

		const minutes = Math.floor(diff / (1000 * 60));
		const hours = Math.floor(diff / (1000 * 60 * 60));
		const days = Math.floor(diff / (1000 * 60 * 60 * 24));

		if (secondsLeft <= 60) {
		  return 'in less than a minute';
		} else if (minutes < 60) {
		  return `in ${minutes} minute${minutes > 1 ? 's' : ''}`;
		} else if (hours < 24) {
		  return `in ${hours} hour${hours > 1 ? 's' : ''}`;
		} else {
		  return `in ${days} day${days > 1 ? 's' : ''}`;
		}
	}
}
